var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{attrs:{"type":_vm.typeIcon,"custom":_vm.customIcon,"size":_vm.size,"color":_vm.color},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }